var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinnBlack = function SvgFinnBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 26,
    viewBox: "0 0 75 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FINN-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 26V0h16.604v6.245H6.319v4.617h7.941v6.245H6.32V26zM26.454 0h-6.32v26h6.32zm17.949 13.19V0h6.319v26h-5.073l-9.355-14.17V26h-6.31V0h5.785zm24.278 0V0H75v26h-5.083l-9.345-14.17V26h-6.32V0h5.795z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FINN-black_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h75v26H0z"
  })))));
};
export { SvgFinnBlack as ReactComponent };